import { createContext } from "react";

export const RegisterModalContext = createContext();
